// @ts-nocheck
import { shippingMethodStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { orderDetailsSubTitle } from "@store/Themes/common/props/orderDetails";

Object.assign(shippingMethodStyles, {
    wrapper: orderDetailsSubTitle.wrapper,
    titleText: orderDetailsSubTitle.titleText,
});
